import { render, staticRenderFns } from "./AccSetting.vue?vue&type=template&id=28c24051"
import script from "./AccSetting.vue?vue&type=script&lang=js"
export * from "./AccSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports